import { render } from "./SelectedBoxMenuParameter.vue?vue&type=template&id=7748ca30&scoped=true"
import script from "./SelectedBoxMenuParameter.vue?vue&type=script&lang=ts"
export * from "./SelectedBoxMenuParameter.vue?vue&type=script&lang=ts"

import "./SelectedBoxMenuParameter.vue?vue&type=style&index=0&id=7748ca30&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7748ca30"

export default script